module.exports = __webpack_public_path__ + "img/resources-1920.f9a592b2.jpg";